var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"color-content"},[_c('div',{staticClass:"color-banner-image",style:({ backgroundImage: `url(${_vm.colorBannerImageSrc})` })}),_c('div',{staticClass:"color-overlay-image"},[_c('h1',{staticClass:"color-banner-title"},[_vm._v(_vm._s(_vm.colorBannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }